import { getUniqueId } from './get-unique-id';

export function addKey<T>(items: T[]): T[] {
  for (const item of items) {
    (item as any)['_key'] = getUniqueId('key');
  }
  return items;
}
